import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BeefIcon, LeafIcon, WheatIcon, DropletIcon } from 'lucide-react';
export function WhyBajoPerfil() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const features = [{
    Icon: BeefIcon,
    text: 'Carnes marinadas'
  }, {
    Icon: LeafIcon,
    text: 'Vegetales frescos'
  }, {
    Icon: WheatIcon,
    text: 'Pan artesanal'
  }, {
    Icon: DropletIcon,
    text: 'Salsas caseras'
  }];
  return <section className="w-full bg-bp-bg py-20 px-6 md:px-20 border-t border-bp-line" data-id="element-132">
      <div className="max-w-container mx-auto" data-id="element-133">
        <motion.h2 ref={ref} className="font-display text-[32px] md:text-[48px] leading-none text-bp-text tracking-[0.1em] uppercase mb-16 text-center" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-134">
          ¿POR QUÉ BAJO PERFIL?
        </motion.h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12" data-id="element-135">
          {features.map((feature, index) => {
          const {
            Icon
          } = feature;
          return <motion.div key={index} className="text-center" initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} data-id="element-136">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center" data-id="element-137">
                  <Icon className="w-10 h-10 text-bp-accent" strokeWidth={1} aria-hidden="true" data-id="element-138" />
                </div>
                <p className="font-body font-light text-bp-text2 text-sm md:text-base" data-id="element-139">
                  {feature.text}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}